const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Public file serve for shared study links — no Authorization header */
export const shareFileServeUrl = (token, fileId, sliceIdx = null) => {
  const base = `${API}/shares/${token}/files/${fileId}/serve`;
  if (sliceIdx == null) return base;
  return `${base}?slice=${sliceIdx}`;
};

export async function fetchPublicShare(token) {
  const res = await fetch(`${API}/shares/${token}`);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.detail || "Request failed");
    err.status = res.status;
    throw err;
  }
  return body;
}

export async function publicFetchBlob(url) {
  const res = await fetch(url);
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.detail || "Request failed");
    err.status = res.status;
    throw err;
  }
  return res.blob();
}

/** Match ImageViewer axios blob handling — DWV needs application/dicom MIME */
export async function publicFetchDicomBlob(url, signal = null) {
  const res = await fetch(url, signal ? { signal } : undefined);
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.detail || "Request failed");
    err.status = res.status;
    throw err;
  }
  const data = await res.arrayBuffer();
  if (!data?.byteLength) throw new Error("Empty DICOM response");
  return new Blob([data], { type: "application/dicom" });
}
